import React, { useState } from "react";
import { Link } from "react-router-dom";
// images
import logo from "../../../assets/images/logo-icon.png";
import logoText from "../../../assets/images/logo-text.png";

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo nav-headerbg ">
        <img className="logo-abbr " src={logo} alt="logoimg" />
        <img className="logo-compact mr-5" src={logoText} alt="logotext" />
        <img className="brand-title" src={logoText} alt="logobrand" />
      </Link>

      <div className="nav-control mt-2" onClick={() => setToggle(!toggle)}>
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
